import React, { useState, useEffect } from 'react'
import { Panel, Message, Table } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ProjectClosedLateForm from './ProjectClosedLateForm'
import ProjectClosedLateTable from './ProjectClosedLateTable'
import ProjectLawTrackingNoteWidget from './ProjectLawTrackingNoteWidget'
import {
  getManageLawProjectTracking,
  getManageProjectTracking,
} from '../../../redux/actions/adminManageLawProjectTracking'

export default function LawProjectTrackingWidget(props) {
  const { Column, HeaderCell, Cell } = Table
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(props.schema.form)
  const [errorMsg, setErrorMsg] = useState()
  const [dataTable, setDataTable] = useState(props.schema.searchResult || [])
  const [dataTracking, setDataTracking] = useState()
  const [expandedSearch, setExpandedSearch] = useState(true)
  const [onClear, setOnClear] = useState(false)
  const [rowData, setRowData] = useState()

  useEffect(() => {
    // setDataTable(mockSchemaSearch)
  }, [])

  const onSubmit = (data) => {
    console.log('onSubmit 1', data)
    const request = {
      projectCode: data.projectCode || null,
      projectName: data.projectName || null,
      pageNumber: 1,
      pageSize: 5,
    }

    // handleGetSchema(request)
  }

  const handelGetSchemaOnReload = async (pagesize, pagenumber) => {
    console.log('handelGetSchemaOnReload ', pagesize, pagenumber)

    const request = {
      projectCode: null,
      projectName: null,
      pageNumber: pagenumber,
      pageSize: pagesize,
    }

    handleGetSchema(request)
  }

  const onSelect = async (data) => {
    console.log('data => ', data)
    setExpandedSearch(false)
    setRowData(data)
    handleGetSchemaProjectTracking(data.projectId)
  }

  const onCancel = async () => {
    console.log('on cancel')
    setOnClear(!onClear)
    const request = {
      projectCode: null,
      projectName: null,
      pageNumber: 1,
      pageSize: 5,
    }

    handleGetSchema(request)
  }

  const handleGetSchema = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getManageLawProjectTracking(request)

      setDataTable(_schema.model.searchResult)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemaProjectTracking = async (projectId) => {
    // setIsLoading(true)
    startLoading()
    try {
      const _schema = await getManageProjectTracking(projectId)
      console.log('schema ', _schema)
      setDataTracking(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    // setIsLoading(false)
  }

  const handleCloseProjectTracking = async () => {
    setExpandedSearch(true)
  }

  const handleSaveSuccess = (projectId) => {
    handleGetSchemaProjectTracking(projectId)
  }

  const handleSetExpandedSearch = () => {
    setExpandedSearch(true)
    onCancel()
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.searchObject.header}
        collapsible
        defaultExpanded
        expanded={expandedSearch}
        ref={(section) => {
          setSection(section)
        }}
        onSelect={() => {
          handleSetExpandedSearch()
        }}
      >
        <>
          <ProjectClosedLateForm
            schema={formSchema.searchObject}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            handelPreview={onSubmit}
            onClear={onClear}
          />

          {/* <hr /> */}

          {errorMsg && (
            <Message
              showIcon
              type={errorMsg.type}
              description={errorMsg.description}
              style={{ marginBottom: 20 }}
            />
          )}

          <ButtonPanelWidget
            isEdit={true}
            isError={isError}
            buttonText={formSchema.searchObject.buttonText}
            onSave={handleSubmit(onSubmit)}
            onCancel={handleSubmit(onCancel)}
          />

          {dataTable && (
            <ProjectClosedLateTable
              schema={dataTable}
              Controller={Controller}
              control={control}
              pagination={true}
              loading={isLoading}
              hideColumn={{ dayOfDelay: true }}
              onReload={handelGetSchemaOnReload}
              onSelect={onSelect}
            />
          )}
        </>
      </Panel>

      {dataTracking && !expandedSearch && (
        <ProjectLawTrackingNoteWidget
          schema={dataTracking}
          onClose={handleCloseProjectTracking}
          rowData={rowData}
          onSaveSuccess={handleSaveSuccess}
        />
      )}

      <br />
    </>
  )
}
